import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import InputField from "components/fields/InputField";
import Google from "api/Google";
import LocationModel from "../../models/Location";
import Company from "api/Company";
import Collection from "models/Collection";

export default function GoogleLocationView(props) {
  const { t, i18n } = useTranslation("modals");
  const [open, setOpen] = useState(true);
  const [newLocation, setNewLocation] = useState(null);
  const [locations, setLocations] = useState(null);

  const handleClose = () => {
    setOpen(false);
    if (props.onHideEvent) {
      props.onHideEvent();
    }
  };

  if (!locations) {
    Company.getLocations().then((response) => {
      let items = new Collection().addData(
        response.data.data,
        new LocationModel()
      );
      setLocations(items);
    });
  }

  const searchLocation = (event) => {
    event.preventDefault();
    let locationStr = event.target.elements.locationAddress.value;
    let result = Google.getSearchLocation(locationStr)
      .then(function (response) {
        if (response instanceof LocationModel) {
          setNewLocation(response);
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  const saveLocation = (event) => {
    event.preventDefault();
    let result = Company.storeLocation(newLocation.getData())
      .then(function (response) {
        var newLocationModel = new LocationModel();
        newLocationModel.addData(response.data.data.data);
        useLocation(event, newLocationModel);
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  const useLocation = (event, item) => {
    event.preventDefault();
    props.modalview.saveEvent(item);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity bg-black/80" />
        </Transition.Child>

        <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
          <div className="flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="overflow-hidden relative text-left bg-white shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={searchLocation}>
                  <div className="px-4 pt-5 pb-4 sm:p-6">
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 justify-center items-center mx-auto w-12 h-12 rounded-full bg-primary/10 sm:mx-0 sm:h-10 sm:w-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-primary"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.5926 21.8055L12.5944 21.8042L12.6 21.8001L12.6185 21.7863C12.6341 21.7746 12.6562 21.758 12.6844 21.7365C12.7406 21.6937 12.8211 21.6316 12.9223 21.5514C13.1245 21.3909 13.4102 21.1574 13.7514 20.8594C14.4326 20.2647 15.3426 19.407 16.2553 18.3551C18.0477 16.2895 20 13.3052 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 13.3052 5.95225 16.2895 7.74471 18.3551C8.65744 19.407 9.5674 20.2647 10.2486 20.8594C10.5898 21.1574 10.8755 21.3909 11.0777 21.5514C11.1789 21.6316 11.2594 21.6937 11.3156 21.7365C11.3438 21.758 11.3659 21.7746 11.3815 21.7863L11.4 21.8001L11.4056 21.8042L11.4081 21.806L12 22.2401L12.5926 21.8055ZM11.9978 12.5C13.3785 12.5 14.4978 11.3807 14.4978 10C14.4978 8.61929 13.3785 7.5 11.9978 7.5C10.6171 7.5 9.4978 8.61929 9.4978 10C9.4978 11.3807 10.6171 12.5 11.9978 12.5Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900"
                        >
                          {props.modalview.header}
                        </Dialog.Title>
                      </div>
                    </div>

                    <div className="mt-4">
                      <p className="mb-4 text-sm text-gray-500">
                        {props.modalview.message}
                      </p>

                      {locations && locations.length > 0 && (
                        <div className="mt-6 mb-6">
                          <h4 className="mb-2 font-medium text-gray-900 text-md">
                            Opgeslagen locaties
                          </h4>
                          <div className="grid overflow-y-auto grid-cols-1 gap-4 pr-2 max-h-64">
                            {locations.map((item, index) => (
                              <div
                                key={index}
                                className="p-4 bg-gray-50 rounded-lg border border-gray-200 transition-shadow duration-200 hover:shadow-md"
                              >
                                <div className="text-sm font-medium text-gray-700">
                                  {item.address}
                                </div>
                                <div className="mt-1 text-sm text-gray-500">
                                  {item.zipcode}, {item.place_name}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {item.region}
                                </div>
                                <button
                                  type="button"
                                  className="btn-primary"
                                  onClick={(event) => useLocation(event, item)}
                                >
                                  Gebruik locatie
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="mt-4">
                        <div className="-space-y-px rounded-md shadow-sm">
                          <div>
                            <label
                              htmlFor="locationAddress"
                              className="sr-only"
                            >
                              Locatie
                            </label>
                            <InputField
                              type="text"
                              id="locationAddress"
                              name="locationAddress"
                              className="block px-3 py-2 w-full placeholder-gray-400 text-gray-900 rounded-md border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                              placeholder="Vul hier de locatie in waar het product opgehaald kan worden"
                            />
                          </div>
                        </div>
                        <p
                          className="mt-2 text-xs text-gray-500"
                          id="location-helper-text"
                        >
                          Voorbeeld : Teststraat 1A, Scheveningen
                        </p>
                      </div>
                    </div>
                  </div>

                  {newLocation && (
                    <div className="px-4 py-3 bg-gray-50 sm:px-6">
                      <div className="p-4 bg-green-50 rounded-md">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <svg
                              className="w-5 h-5 text-green-400"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm font-medium text-green-800">
                              Locatie gevonden
                            </h3>
                            <div className="mt-2 text-sm text-green-700">
                              <div className="text-sm font-medium text-gray-700">
                                {newLocation.address}
                              </div>
                              <div className="text-sm text-gray-500">
                                {newLocation.zipcode}, {newLocation.place_name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {newLocation.region}
                              </div>
                            </div>
                            <div className="mt-4">
                              <div className="flex -mx-2 -my-1.5">
                                <button
                                  type="button"
                                  className="px-2 py-1.5 text-sm font-medium text-green-700 bg-green-50 rounded-md hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                                  onClick={(event) => saveLocation(event)}
                                >
                                  Locatie opslaan
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="gap-2 px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button type="submit" className="btn-primary">
                      Zoek locatie
                    </button>
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={handleClose}
                    >
                      Annuleren
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
